import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    const sendPageView = () => {
      if (typeof window.gtag !== 'function') return;

      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: `${location.pathname}${location.search}`,
      });
    };

    const timer = window.setTimeout(sendPageView, 0);
    return () => window.clearTimeout(timer);
  }, [location]);

  return null;
};

export default Analytics;
